<template>
  <div>
    <div
      style="display: flex; align-items: center"
      v-for="(answer, answerIndex) in question.answers"
      :key="answerIndex"
    >
      <div style="display: inline-flex">{{ `${answer.label}`.toLowerCase() }}.</div>
      <div v-html="answer.value || ''" style="margin-left: 4px"></div>
      <span
        v-if="!submission.isQuestionPaper && isStudentAnswerCorrectShown"
        class="ml-2"
        :style="{color: submission.isStudentWork ? '#000' : isCorrect(answer.key) ? '#4bca81' : '#d4504c'}"
      >
        {{ convertText(studentAnswer(answer.key)) }}
      </span>
    </div>
    <!-- <div class="mt-2" v-if="!submission.isQuestionPaper && !isCorrectHidden"> -->
    <div class="mt-2" v-if="!submission.isQuestionPaper && !submission.isStudentWork && !isCorrectHidden">
      <span class="font-weight-medium">Đáp án:&nbsp;</span>
      <div v-for="(answer, answerIndex) in correctAnswer()" :key="answerIndex">
        <span>{{ answer.label.toLowerCase() }}-</span>
        <span class="green--text">{{ convertText(answer.value) }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import get from 'lodash-es/get'
export default {
  props: {
    question: Object,
    isCorrectHidden: Boolean,
    isStudentAnswerCorrectShown: {type: Boolean, default: true},
  },
  computed: {
    ...mapGetters({
      submission: 'pdfRender/getSubmission',
    }),
  },
  methods: {
    isCorrect(key) {
      const studentAnswer = get(this.submission, `answers.${this.question.id}`)
      return studentAnswer ? studentAnswer.correct[key] === studentAnswer.answers[key] : ''
    },
    convertText(text) {
      if (text == 'true' || text == true) {
        return 'Đ'
      }
      if (text == false) {
        return 'S'
      }
      return ''
    },
    studentAnswer(ansKey = '') {
      const studentAnswer = get(this.submission, `answers.${this.question.id}`)
      return studentAnswer ? studentAnswer.answers[ansKey] : ''
    },
    correctAnswer() {
      let question = get(this.submission, 'questions', []).find(item => item.id === this.question.id)
      let correct = Object.values(this.question.answers).map(item => {
        return {
          value: question.correct[item.key],
          label: item.label,
        }
      })
      return correct
    },
  },
}
</script>
